module.exports = __webpack_public_path__ + "static/media/kahf_home_banner.7ed1039f.jpg";